module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_more-2a8e73a8866ce6799520e4cf33941c9f.svg";